import { useNavigate } from "react-router-dom";
import CustomButton from "components/CustomButton/CustomButton";
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import CustomSelect from "components/CustomSelect/CustomSelect";
import { ContainerTranslate } from "components/DialogAlertNotify/styles";
import { HelperText } from "components/styles";
import { useState } from "react";
import { requestTranslateStudents } from "services/events/aboutEvents";

const { default: DialogAlert } = require("components/DialogAlert/DialogAlert")

const ModalTraspaso = ({
    active,
    handleClose,
    data,
    events,
    eventDetail
}) => {

    const navigate = useNavigate();

    const [selectedStudents, setSelectedStudents] = useState([]);
    const [selectEvent, setSelectEvent] = useState(null);
    const [selectError, setSelectError] = useState("");
    const [studentsError, setStudentsError] = useState("");
    const [hasErrorSelect, setHasErrorSelect] = useState(false);
    const [hasErrorStudents, setHasErrorStudents] = useState(false);
    const [selectedAllStudents, setSelectedAllStudents] = useState(false);

    const handleSelectChange = (value, text) => {
        if(value > 0){
            setHasErrorSelect(false);
        }
        setSelectEvent(value);
    };

    const handleCheckboxChange = (value) => {
        setHasErrorStudents(false);
        setSelectedStudents((prevSelected) =>
            prevSelected.includes(value)
                ? prevSelected.filter((item) => item !== value)
                : [...prevSelected, value]
        );

    };

    const buildRequestBody = () => {
        return {
        IdEventoOrigen: eventDetail.id,
        IdEventoDestino: selectEvent,
        AlumnosTraspaso: selectedStudents
        };
    };


    const handleSave = async() => {
        let hasError = false;

        // Validar evento destino
        if (!selectEvent) {
            setSelectError("Debe seleccionar un evento*");
            setHasErrorSelect(true);
            hasError=true
        } else {
            setSelectError("");
        }

        // Validar alumnos seleccionados
        if (selectedStudents.length === 0) {
            setStudentsError("Debe seleccionar al menos un alumno para el traspaso*");
            setHasErrorStudents(true);
            hasError=true
        } else {
            setStudentsError("");
        }

        // Si hay errores, no continúa
        if (hasError) return;

        const body = buildRequestBody();
        requestTranslateStudents(body.IdEventoOrigen, body.IdEventoDestino, body.AlumnosTraspaso);
        navigate("/eventos")
    };

    const handleSelectedAllStudents = () => {
        if(selectedAllStudents){
            setSelectedStudents([]);
            setSelectedAllStudents(false);
            return;
        }
        const students = data.map(item => item.id);
        setSelectedStudents(students);
        setSelectedAllStudents(true)
    }

    return (
        <DialogAlert
            show={active}
        >
            <ContainerTranslate gap="15px">
                <h3>Traspaso de alumnos</h3>

                <div>
                    <p><strong>Evento Origen:</strong> {eventDetail.title}</p>
                    <p><strong>Evento Destino:</strong></p>
                    <div>
                        <CustomSelect
                        value = {selectEvent}
                        onChange={handleSelectChange}
                        optionsProps = {events.filter(event => (event.idEvento !== eventDetail.id && !event.traspaso)).map(
                            ({ idEvento, titulo, seccion }) => {
                                return {
                                    value: idEvento,
                                    text: `(${seccion}) - ${titulo}`,
                                }
                            }
                        )}
                        defaultOptionText="Seleccione el evento"
                        error={hasErrorSelect}
                        required
                        />
                        {hasErrorSelect && 
                            <HelperText style={{ color: "red", fontSize: "13px" }}>
                                {selectError}
                            </HelperText>}
                    </div>

                    <p><strong>Alumnos a traspasar {` (${data.length}) `}: </strong></p>
                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                        {data.length === 0 ? (
                            // 🔹 Empty State cuando no hay datos
                            <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                                No hay alumnos inscritos para mostrar.
                            </div>
                        ) : (

                            data.map((item) => (
                                <CustomCheckbox
                                    key={item.id}
                                    label={`${item.name} (${item.id})`}
                                    checked={selectedStudents.includes(item.id)}
                                    onChange={() => handleCheckboxChange(item.id)}
                                    disabled={false}
                                    padding="8px"
                                />
                            ))
                        )}
                    </div>
                    <CustomCheckbox
                        label={`Todos los inscritos`} 
                        variant="switch"
                        checked={selectedAllStudents}
                        onChange={handleSelectedAllStudents}
                    />
                    {hasErrorStudents && (
                        <HelperText style={{ color: "red", fontSize: "13px" }}>
                            {studentsError}
                        </HelperText>
                    )}

                </div>

                <footer>
                    <CustomButton
                        text="Cancelar"
                        onClick={handleClose}
                    />
                    <CustomButton
                        text="Guardar"
                        onClick={handleSave}
                    />
                </footer>
            </ContainerTranslate>

        </DialogAlert>
    )
}

export default ModalTraspaso;